module.exports = __webpack_public_path__ + "static/media/magic-wand.09784443.png";